module.exports = __webpack_public_path__ + "img/Karol Podufalski.fc0eff97.jpg";